import { computed, h, defineComponent } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { activeIssueEditable } from '@/ui/pages/conduct/ConductInspectionStore';

export const PrefilledFields = defineComponent({
  name: 'PrefilledFields',
  setup() {
    const showTitle = computed(
      () => (
        activeIssueEditable.value!.params.title || activeIssueEditable.value!.params.description
      ),
    );

    const showSeparator = computed(() => (
      activeIssueEditable.value!.params.title || activeIssueEditable.value!.params.description
    ));

    const showDescription = computed(() =>
      !activeIssueEditable.value!.settings.description_enabled && activeIssueEditable.value!.params.description);

    return function render() {
      return h('div', [
        showTitle.value ? t('issues.fields-prefilled') : null,

        !activeIssueEditable.value!.settings.title_enabled
          ? h('div', [
            h('div', { class: 'has-text-weight-semibold mt-4 pre-fill-text-title' }, t('common.title')),
            h('div', activeIssueEditable.value!.params.title),
          ]) : null,

        showDescription.value
          ? h('div', [
            h('div', { class: 'has-text-weight-semibold mt-4 pre-fill-text-title' }, t('common.description')),
            h('div', activeIssueEditable.value!.params.description),
          ]) : null,

        showSeparator.value ? h('hr') : null,
      ]);
    };
  },
});
